export default "__VITE_ASSET__d87c0b11__"